exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".password-reset.component {\n  display: flex;\n  flex:1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.password-reset.component input {\n  margin-bottom: 6px;\n}\n\n.password-reset.component .wrapper{\n  min-width: 60px;\n  max-width: 200px;\n  width: 100%;\n  padding: 12px;\n  text-align: center;\n}\n\n.password-reset.component .wrapper button {\n  width: 100%;\n  height: 32px;\n}\n\n.password-reset.component .logo-wrapper {\n  margin-bottom: 30px !important;\n  width: 100%;\n}\n\n.password-reset.component img{\n  width:60%;\n  height:auto;\n  opacity: 0.9;\n}\n\n.password-reset.component video{\n  position: absolute;\n  min-height: 100%;\n  min-width: 100%;\n  width: auto;\n  height: auto;\n  z-index: -100;\n  overflow: hidden;\n}\n\n.password-reset.component .login-error{\n  color: #FFFFFF;\n}\n\n.password-reset.component .chrome-message{\n  color: #FFFFFF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/user/password-reset.css
// module id = 508
// module chunks = 0